GZ.datePicker = {
  locale: {
    weekdays: {
      shorthand: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
      longhand: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag']
    },

    months: {
      shorthand: ['jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 'aug', 'sept', 'okt', 'nov', 'dec'],
      longhand: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
    },

    firstDayOfWeek: 1,

    ordinal: function(nth){
      if (nth === 1 || nth === 8 || nth >= 20) {
        return "ste";
      }

      return "de";
    }
  },

  options: {
    enableTime: true,
    time_24hr: true,
    weekNumbers: true,
    dateFormat: "d-m-Y H:i",
    // dateFormat: "l, j F Y  - H:i",
    altInput: true,
    altFormat: "l, j F Y  - H:i",
    defaultDate: new Date(),
    minuteIncrement: 15,
    minDate: "today",
    mode: "single"
  },

  init: function(){
    this.options.locale = this.locale;

    this.options.onChange = this.onChangeDate.bind(this);

    this.rentFrom = $("#client_from_datetime");
    this.rentTo = $("#client_to_datetime");

    this.addIncrementDays();

    var from = {};
    $.extend(from, this.options);

    var now = new Date();
    now.setHours(8);
    now.setMinutes(0);
    now.setSeconds(0);

    from.defaultDate = now;

    console.log(now);


    var to = {};
    $.extend(to, this.options);


    var till = now.fp_incr(1);
    till.setHours(8);
    till.setMinutes(0);
    till.setSeconds(0);

    to.defaultDate = till;
    to.minDate = till;

    this.rentFrom.flatpickr(from);
    this.rentTo.flatpickr(to);
  },

  addIncrementDays: function(){
    Date.prototype.addDays = function(days) {
      var dat = new Date(this.valueOf());
      dat.setDate(dat.getDate() + days);
      return dat;
    }
  },

  onChangeDate: function(event, dateStr, instance){
    var rentFromDate, daysBetween;
    if(instance !== undefined){
      console.log("instance", instance);
      console.log("instance.input", instance.input);
      console.log("instance.input === this.rentFrom[0]", instance.input === this.rentFrom[0]);

      if(instance.input === this.rentFrom[0]) {
        // if (this.rentFrom[0]._flatpickr._selectedDateObj !== undefined) {
        //   rentFromDate = this.rentFrom[0]._flatpickr._selectedDateObj.fp_incr(1);
        //   daysBetween = this.rentTo[0]._flatpickr._selectedDateObj.getTime() - this.rentFrom[0]._flatpickr._selectedDateObj.getTime();
        // } else {
          rentFromDate = this.rentFrom[0]._flatpickr.selectedDates[0].fp_incr(1);
          daysBetween = this.rentTo[0]._flatpickr.selectedDates[0].getTime() - this.rentFrom[0]._flatpickr.selectedDates[0].getTime();
        // }
        rentFromDate.setHours(8);
        rentFromDate.setMinutes(0);
        rentFromDate.setSeconds(0);
        this.rentTo[0]._flatpickr.config._minDate = this.rentFrom[0]._flatpickr.selectedDates[0].fp_incr(1);

        if (daysBetween <= 0) {
          this.rentTo[0]._flatpickr.setDate(rentFromDate);
        }
      }
      $("#hidden_from_time").val(this.rentFrom[0]._flatpickr.formatDate(this.rentFrom[0]._flatpickr.selectedDates[0], "d-m-Y H:i"));
      $("#hidden_to_time").val(this.rentTo[0]._flatpickr.formatDate(this.rentTo[0]._flatpickr.selectedDates[0], "d-m-Y H:i"));
      GZ.rentCar._summary.rentFrom.html( this.rentFrom[0]._flatpickr.formatDate(this.rentFrom[0]._flatpickr.selectedDates[0], "l, j F Y  - H:i") );
      GZ.rentCar._summary.rentTo.html( this.rentTo[0]._flatpickr.formatDate(this.rentTo[0]._flatpickr.selectedDates[0], "l, j F Y  - H:i") );

      this.calculatePrice();
    }
    console.log("arguments", arguments);
  },

  calculatePrice: function() {
    var currentCarDetails = GZ.rentCar.getCurrentCar();
    if (!currentCarDetails) {
      console.log('currentCarDetails are not found');
    }

    // flatpickr objects
    var fromFlatPickr = this.rentFrom[0]._flatpickr;
    var toFlatPickr = this.rentTo[0]._flatpickr;

    // selected date objects
    var fromDate = fromFlatPickr.selectedDates[0];
    var toDate = toFlatPickr.selectedDates[0];

    // zet huurtijd op 8 uur 's ochtends
    fromDate.setHours(8);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);

    // als de inlevertijd later is dan 8 uur 's ochtends betaal dan tot de volgende dag 8 uur 's ochtends
    if (toDate.getHours() > 8 || toDate.getHours() == 8 && toDate.getMinutes() > 0) {
      toDate = toDate.addDays(1);
    }

    toDate.setHours(8);
    toDate.setMinutes(0);
    toDate.setSeconds(0);

    // days between
    var oneDay = 24*60*60*1000; // time of one day
    var daysBetween = Math.round(Math.abs((fromDate.getTime() - toDate.getTime())/(oneDay)));

    // weekdays
    var fromWeekday = fromFlatPickr.formatDate(fromFlatPickr.selectedDates[0], "w");
    var toWeekday = toFlatPickr.formatDate(toFlatPickr.selectedDates[0], "w");


    var differentPrices = this.getDifferentPrices(fromWeekday, daysBetween);

    var pricingstable = $(".car-rent-price-calculation .table");

    console.log("GZ.rentCar._currentPricings", GZ.rentCar._currentPricings);

    pricingstable.html(this.generatePriceElements(differentPrices));

    var weeksTotal = GZ.rentCar._currentPricings[2] * differentPrices.weeks;
    var weekendsTotal = GZ.rentCar._currentPricings[1] * differentPrices.weekends;
    var daysTotal = GZ.rentCar._currentPricings[0] * differentPrices.days;

    var totalprice = Number(weeksTotal) + Number(weekendsTotal) + Number(daysTotal);
    console.log("totalprice without extra options", totalprice);

    var extraOptionsPrice = this.calculateExtraOptions(daysBetween);

    totalprice += extraOptionsPrice;
    console.log("totalprice", totalprice);


    var deposit = this.getDepositBasedOnOptions(currentCarDetails.deposit);
    // totalprice += deposit;

    $('.summary .car-rent-subtotal .deposit-amount').html(deposit);

    var totalpriceFormat = this.priceFormat(totalprice);
    totalpriceFormat = "&euro; " + totalpriceFormat;

    GZ.rentCar._summary.price.html(totalpriceFormat);
  },

  getDepositBasedOnOptions: function(deposit) {
    var discountToggle = $("#rent-car-formholder #client_extra_options input[data-discount-toggle=true]:checked");
    if(discountToggle.length) return deposit.discount;

    return deposit.default;
  },

  getDifferentPrices: function(fromWeekday, daysBetween){
    var weekends = [0, 6]; // zondag en zaterdag
    var currentWeekday = fromWeekday;

    var daysLeft = daysBetween;
    var weeks = Math.floor(daysBetween / 7);
    var weekends = false;

    daysLeft = daysLeft - (weeks * 7);

    if(daysLeft > 0){
      var days = [];
      for (var i = 0; i < daysLeft; i++) {
        if(currentWeekday >= 6){
          currentWeekday = 0;
        } else {
          currentWeekday++;
        }
        days.push(currentWeekday);
      }

      var monday = false;
      var sunday = false;

      for (var i = 0; i < days.length; i++) {
        if(days[i] == 0){
          sunday = true;
        } else if(days[i] == 1){
          monday = true;
        }
      }

      if(sunday && monday){
        weekends = true;
        daysLeft = daysLeft-2;
      }
    }

    return{
      weeks: weeks,
      weekends: (weekends) ? 1 : 0,
      days: daysLeft
    }
  },

  calculateExtraOptions: function(daysBetween){
    var priceElem = null;
    var price = 0;
    var pricePerDay = false;
    var extraOptionsPrice = 0;
    var checkedValues = $("#rent-car-formholder").find("#client_extra_options input:checked");
    checkedValues.each( function(){
      priceElem = $(this).parent().find('.option-price');
      pricePerDay = priceElem.attr('data-price-per-day');
      price = priceElem.text();
      price = parseInt(price.split(' ')[1]);

      console.log('pricePerDay', pricePerDay);

      price = (pricePerDay != 'false') ? price * daysBetween : price;

       console.log('price', price);

      extraOptionsPrice += parseInt(price);
    });

    return extraOptionsPrice;
  },

  generatePriceElements: function(differentPrices){
    var htmlObjs = [];
    var weeks = differentPrices.weeks;
    var weekends = differentPrices.weekends;
    var days = differentPrices.days;

    console.log("differentPrices", differentPrices);

    var weeksTotal = GZ.rentCar._currentPricings[2] * weeks;
    var weekendsTotal = GZ.rentCar._currentPricings[1] * weekends;
    var daysTotal = GZ.rentCar._currentPricings[0] * days;

    var weeksTotalFormat = this.priceFormat(weeksTotal);
    var weekendsTotalFormat = this.priceFormat(weekendsTotal);
    var daysTotalFormat = this.priceFormat(daysTotal);

    htmlObjs.push([
      '<table class="car-rent-pricings">',
      '<tbody>',
      '<tr>',
        '<th class="pricing-label">Tarief</th>',
        '<th class="count">Aantal</th>',
        '<th class="total price">Prijs</th>',
      '</tr>'
    ].join(''));

    if(weeks > 0){
      htmlObjs.push([
        '<tr class="car-rent-pricing">',
          '<td class="label">Weektarief</td>',
          '<td class="count">'+ weeks +'</td>',
          '<td class="count price">&euro; '+ weeksTotalFormat +'</td>',
        '</tr>'
      ].join(''));
    }

    if(weekends > 0){
      htmlObjs.push([
        '<tr class="car-rent-pricing">',
          '<td class="label">Weekendtarief</td>',
          '<td class="count">'+ weekends +'</td>',
          '<td class="count price">&euro; '+ weekendsTotalFormat +'</td>',
        '</tr>'
      ].join(''));
    }

    if(days > 0){
      htmlObjs.push([
        '<tr class="car-rent-pricing">',
          '<td class="label">Dagtarief</td>',
          '<td class="count">'+ days +'</td>',
          '<td class="count price">&euro; '+ daysTotalFormat +'</td>',
        '</tr>'
      ].join(''));
    }

    htmlObjs.push([
        '</tbody>',
      '</table>'
    ].join(''));

    return htmlObjs.join('');
  },

  priceFormat: function(price){
    var amount = price;

    if(amount % 1 != 0){
      amount = amount.toFixed(2);
    }

    var amountString = amount + "";

    // replace dots for comma's
    amountString = amountString.replace(".", ",");

    // seperate thousants with dots
    amountString = amountString.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");

    return amountString;
  }
};
